import { removeNamespace } from '@/utils/helpers'

export const LAYOUT_TYPES = {
  mutations: {
    SET_PAGE_HAS_SLANTED_BACKGROUND: 'layout/SET_PAGE_HAS_SLANTED_BACKGROUND',
    SET_PAGE_LAST_UPDATE_TIME: 'layout/SET_PAGE_LAST_UPDATE_TIME',
    RESET_PAGE_LAST_UPDATE_TIME: 'layout/RESET_PAGE_LAST_UPDATE_TIME'
  },
  actions: {
    setPageLastUpdateTime: 'layout/setPageLastUpdateTime',
    resetPageLastUpdateTime: 'layout/resetPageLastUpdateTime'
  }
}

const _types = removeNamespace('layout', LAYOUT_TYPES)

const state = () => ({
  pageHasSlantedBackground: false,
  pageLastUpdatedDate: null
})

const getters = {}

const mutations = {
  [_types.mutations.SET_PAGE_HAS_SLANTED_BACKGROUND] (state, bool) {
    state.pageHasSlantedBackground = bool
  },
  [_types.mutations.SET_PAGE_LAST_UPDATE_TIME] (state, dates) {
    let lastUpdate = state.pageLastUpdatedDate
    dates.forEach(date => {
      if (lastUpdate === null || date > lastUpdate) {
        lastUpdate = date
      }
    })
    state.pageLastUpdatedDate = lastUpdate
  },
  [_types.mutations.RESET_PAGE_LAST_UPDATE_TIME] (state, defaultDate) {
    state.pageLastUpdatedDate = defaultDate
  }
}

const actions = {
  /**
   * Updates the last updated date for a page. Shown in the footer. Any time entries are queried
   * all their dates are checked through this method and the most recent is selected.
   * When routing to a new page, this value must be reset using the resetPageLastUpdateTime action.
   * Otherwise a page might show an incorrect date (if the previous page has an earlier updated date)
   * @param {Date[]} dates - list of dates to compare to last updated date */
  [_types.actions.setPageLastUpdateTime] ({ commit }, dates) {
    commit(_types.mutations.SET_PAGE_LAST_UPDATE_TIME, dates)
  },
  /**
   * Call when routing to a new page to set the initial lastUpdatedDate to the default date. Note:
   * the defaultDate is the pages last update time, not its children. The lastUpdateDate should reflect
   * children as well. That is why the setPageLastUpdateTime action is dispatched when children are fetched
   * (see contentful.js file).
   * @param {Date} defaultDate - last update date of the page
   */
  [_types.actions.resetPageLastUpdateTime] ({ commit }, defaultDate) {
    commit(_types.mutations.RESET_PAGE_LAST_UPDATE_TIME, defaultDate)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
